import { Logger } from 'sierra-client/core/logging/logger'

type Identifier = `settings_${string}`

export const enableMSTeams = Logger.trackLogger<never>('settings_ms_teams_enable' satisfies Identifier)
